import type { WebsiteContent } from './types'

export const approach: WebsiteContent['approach'] = {
  title: 'Our approach',
  subtitle: "At NXT Humans, we're building a future where AI elevates the people doing it.",
  description:
    'Our mission is to amplify organizations by expanding their capacity to think, create, and adapt.',
  pillars: [
    {
      title: 'AI Native Velocity',
      description:
        'We believe in AI Native Velocity to get insights in minutes and products to market faster. So we built our custom tools and agents for speed and precision. Our Intelligence Augmentation agents deliver insights and recommendations we can immediately act upon.',
    },
    {
      title: 'AI Experiences',
      description:
        'We believe in AI-assisted development to rapidly create interactive experiences, so our platform creates prototypes you can touch, test and iterate on in record time. Bringing to life cutting edge solutions that will drive customer engagement.',
    },
    {
      title: 'Velocity Enablement',
      description:
        'We unlock organizations, committed to AI, with enabling agents, bots, and process optimizations on top of the enterprise investments they have made. We uncover the latent processes and create automations that push the capabilities of AI platforms from Microsoft, Google, and Anthropic.',
    },
  ],
}
